import React from 'react'

import { replaceVariables } from '../../../actions/planning/assignments'

const QuestionStandardTop = ({ question }) => {
  return (
    <div className="item">
      <label>
        {replaceVariables(question.text)} {question.responseRequired ? '*' : ''}
      </label>
      <div className="description">{replaceVariables(question.description)}</div>
    </div>
  )
}

export default QuestionStandardTop
